  <!-- <router-outlet></router-outlet> -->

<div class="wrapper" *ngIf="usuario; else showNoLogin">
  <div class="sidebar" data-color="azure" data-background-color="black" data-image="./assets/img/sidebar-1.jpg">
      <app-sidebar-cmp></app-sidebar-cmp>
      <div class="sidebar-background" style="background-image: url(assets/img/sidebar-image-new-2.jpeg)"></div>
  </div>
  <div class="main-panel">
      <app-navbar-cmp></app-navbar-cmp>
      <router-outlet></router-outlet>
  </div>
</div>

<ng-template #showNoLogin>
  <router-outlet></router-outlet>
</ng-template>